export const ROLES = {
  NONE: 'NONE',
  ADMIN_ONLY: 'ADMIN_ONLY',
  ADMIN_CHAT: 'ADMIN_CHAT',
  CHAT_ONLY: 'CHAT_ONLY',
  CHAT_WITHOUT_THERAPIST: 'CHAT_WITHOUT_THERAPIST'
};

export const CHAT_ROLES = [ROLES.ADMIN_CHAT, ROLES.CHAT_ONLY];
